/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
import { ContentArtistDTO } from "../models";
import { ContentCategoryDTO } from "../models";
import { CreateContentDTO } from "../models";
import { UpdateContentDTO } from "../models";
/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {ContentArtistDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerApplyArtistToContent: async (
      body: ContentArtistDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling contentControllerApplyArtistToContent."
        );
      }
      const localVarPath = `/v1/cms/api/content/artist-apply`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ContentCategoryDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerApplyCategoryToContent: async (
      body: ContentCategoryDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling contentControllerApplyCategoryToContent."
        );
      }
      const localVarPath = `/v1/cms/api/content/category-apply`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateContentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerCreateContent: async (
      body: CreateContentDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling contentControllerCreateContent."
        );
      }
      const localVarPath = `/v1/cms/api/content`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [slug]
     * @param {string} [ticketTraceCode]
     * @param {string} [m3u8FileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerGetCinemaContentM3U8Resource: async (
      slug?: string,
      ticketTraceCode?: string,
      m3u8FileName?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/content/Z2V0Q2luZW1hQ29udGVudE0zVTh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (slug !== undefined) {
        localVarQueryParameter["slug"] = slug;
      }

      if (ticketTraceCode !== undefined) {
        localVarQueryParameter["ticketTraceCode"] = ticketTraceCode;
      }

      if (m3u8FileName !== undefined) {
        localVarQueryParameter["m3u8FileName"] = m3u8FileName;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} anaVatanCity
     * @param {string} anaVatanProvince
     * @param {string} [title]
     * @param {string} [slug]
     * @param {Array} [category]
     * @param {Array} [genre]
     * @param {string} [country]
     * @param {string} [yearStartAt]
     * @param {string} [yearEndAt]
     * @param {string} [timeStartAt]
     * @param {string} [timeEndAt]
     * @param {string} [imdbRateStartAt]
     * @param {string} [imdbRateEndAt]
     * @param {string} [artist]
     * @param {string} [kind]
     * @param {string} [contentAgeRange]
     * @param {string} [status]
     * @param {boolean} [lazyLoading]
     * @param {boolean} [isFree]
     * @param {boolean} [isAnaVatan]
     * @param {boolean} [isLive]
     * @param {boolean} [isTicketing]
     * @param {string} [audioLang]
     * @param {string} [audioLangType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerGetContent: async (
      pageNumber: number,
      pageIndex: number,
      anaVatanCity?: string,
      anaVatanProvince?: string,
      title?: string,
      slug?: string,
      category?: Array,
      genre?: Array,
      country?: string,
      yearStartAt?: string,
      yearEndAt?: string,
      timeStartAt?: string,
      timeEndAt?: string,
      imdbRateStartAt?: string,
      imdbRateEndAt?: string,
      artist?: string,
      kind?: string,
      contentAgeRange?: string,
      status?: string,
      lazyLoading?: boolean,
      isFree?: boolean,
      isAnaVatan?: boolean,
      isLive?: boolean,
      isTicketing?: boolean,
      audioLang?: string,
      audioLangType?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling contentControllerGetContent."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling contentControllerGetContent."
        );
      }

      const localVarPath = `/v1/cms/api/content`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (title !== undefined) {
        localVarQueryParameter["title"] = title;
      }

      if (slug !== undefined) {
        localVarQueryParameter["slug"] = slug;
      }

      if (category !== undefined) {
        localVarQueryParameter["category"] = category;
      }

      if (genre !== undefined) {
        localVarQueryParameter["genre"] = genre;
      }

      if (country !== undefined) {
        localVarQueryParameter["country"] = country;
      }

      if (yearStartAt !== undefined) {
        localVarQueryParameter["yearStartAt"] = yearStartAt;
      }

      if (yearEndAt !== undefined) {
        localVarQueryParameter["yearEndAt"] = yearEndAt;
      }

      if (timeStartAt !== undefined) {
        localVarQueryParameter["timeStartAt"] = timeStartAt;
      }

      if (timeEndAt !== undefined) {
        localVarQueryParameter["timeEndAt"] = timeEndAt;
      }

      if (imdbRateStartAt !== undefined) {
        localVarQueryParameter["imdbRateStartAt"] = imdbRateStartAt;
      }

      if (imdbRateEndAt !== undefined) {
        localVarQueryParameter["imdbRateEndAt"] = imdbRateEndAt;
      }

      if (artist !== undefined) {
        localVarQueryParameter["artist"] = artist;
      }

      if (kind !== undefined) {
        localVarQueryParameter["kind"] = kind;
      }

      if (contentAgeRange !== undefined) {
        localVarQueryParameter["contentAgeRange"] = contentAgeRange;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      if (lazyLoading !== undefined) {
        localVarQueryParameter["lazyLoading"] = lazyLoading;
      }

      if (isFree !== undefined) {
        localVarQueryParameter["isFree"] = isFree;
      }

      if (isAnaVatan !== undefined) {
        localVarQueryParameter["isAnaVatan"] = isAnaVatan;
      }

      if (isLive !== undefined) {
        localVarQueryParameter["isLive"] = isLive;
      }

      if (isTicketing !== undefined) {
        localVarQueryParameter["isTicketing"] = isTicketing;
      }

      if (audioLang !== undefined) {
        localVarQueryParameter["audioLang"] = audioLang;
      }

      if (audioLangType !== undefined) {
        localVarQueryParameter["audioLangType"] = audioLangType;
      }

      if (anaVatanCity !== undefined) {
        localVarQueryParameter["anaVatanCity"] = anaVatanCity;
      }

      if (anaVatanProvince !== undefined) {
        localVarQueryParameter["anaVatanProvince"] = anaVatanProvince;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerGetContentCountries: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/content-country`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerGetContentGlobalSharedVar: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/content/global-variables`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerGetContentImageMedia: async (
      filename: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filename' is not null or undefined
      if (filename === null || filename === undefined) {
        throw new RequiredError(
          "filename",
          "Required parameter filename was null or undefined when calling contentControllerGetContentImageMedia."
        );
      }
      const localVarPath = `/v1/cms/api/content-media/{filename}/image`.replace(
        `{${"filename"}}`,
        encodeURIComponent(String(filename))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [slug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerGetContentPlayerResource: async (
      slug?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/content/player-resource`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (slug !== undefined) {
        localVarQueryParameter["slug"] = slug;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerGetContentVideoMedia: async (
      filename: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filename' is not null or undefined
      if (filename === null || filename === undefined) {
        throw new RequiredError(
          "filename",
          "Required parameter filename was null or undefined when calling contentControllerGetContentVideoMedia."
        );
      }
      const localVarPath = `/v1/cms/api/content-media/{filename}/video`.replace(
        `{${"filename"}}`,
        encodeURIComponent(String(filename))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateContentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerUpdateContent: async (
      body: UpdateContentDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling contentControllerUpdateContent."
        );
      }
      const localVarPath = `/v1/cms/api/content`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentControllerUploadContentMedia: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/content-media/upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {ContentArtistDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerApplyArtistToContent(
      body: ContentArtistDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerApplyArtistToContent(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {ContentCategoryDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerApplyCategoryToContent(
      body: ContentCategoryDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerApplyCategoryToContent(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateContentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerCreateContent(
      body: CreateContentDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerCreateContent(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} [slug]
     * @param {string} [ticketTraceCode]
     * @param {string} [m3u8FileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetCinemaContentM3U8Resource(
      slug?: string,
      ticketTraceCode?: string,
      m3u8FileName?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerGetCinemaContentM3U8Resource(
        slug,
        ticketTraceCode,
        m3u8FileName,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} anaVatanCity
     * @param {string} anaVatanProvince
     * @param {string} [title]
     * @param {string} [slug]
     * @param {Array} [category]
     * @param {Array} [genre]
     * @param {string} [country]
     * @param {string} [yearStartAt]
     * @param {string} [yearEndAt]
     * @param {string} [timeStartAt]
     * @param {string} [timeEndAt]
     * @param {string} [imdbRateStartAt]
     * @param {string} [imdbRateEndAt]
     * @param {string} [artist]
     * @param {string} [kind]
     * @param {string} [contentAgeRange]
     * @param {string} [status]
     * @param {boolean} [lazyLoading]
     * @param {boolean} [isFree]
     * @param {boolean} [isAnaVatan]
     * @param {boolean} [isLive]
     * @param {boolean} [isTicketing]
     * @param {string} [audioLang]
     * @param {string} [audioLangType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContent(
      pageNumber: number,
      pageIndex: number,
      anaVatanCity?: string,
      anaVatanProvince?: string,
      title?: string,
      slug?: string,
      category?: Array,
      genre?: Array,
      country?: string,
      yearStartAt?: string,
      yearEndAt?: string,
      timeStartAt?: string,
      timeEndAt?: string,
      imdbRateStartAt?: string,
      imdbRateEndAt?: string,
      artist?: string,
      kind?: string,
      contentAgeRange?: string,
      status?: string,
      lazyLoading?: boolean,
      isFree?: boolean,
      isAnaVatan?: boolean,
      isLive?: boolean,
      isTicketing?: boolean,
      audioLang?: string,
      audioLangType?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerGetContent(
        pageNumber,
        pageIndex,
        anaVatanCity,
        anaVatanProvince,
        title,
        slug,
        category,
        genre,
        country,
        yearStartAt,
        yearEndAt,
        timeStartAt,
        timeEndAt,
        imdbRateStartAt,
        imdbRateEndAt,
        artist,
        kind,
        contentAgeRange,
        status,
        lazyLoading,
        isFree,
        isAnaVatan,
        isLive,
        isTicketing,
        audioLang,
        audioLangType,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentCountries(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerGetContentCountries(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentGlobalSharedVar(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerGetContentGlobalSharedVar(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentImageMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerGetContentImageMedia(filename, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} [slug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentPlayerResource(
      slug?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerGetContentPlayerResource(slug, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentVideoMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerGetContentVideoMedia(filename, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {UpdateContentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerUpdateContent(
      body: UpdateContentDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerUpdateContent(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerUploadContentMedia(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ContentApiAxiosParamCreator(
        configuration
      ).contentControllerUploadContentMedia(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {ContentArtistDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerApplyArtistToContent(
      body: ContentArtistDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerApplyArtistToContent(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ContentCategoryDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerApplyCategoryToContent(
      body: ContentCategoryDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerApplyCategoryToContent(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateContentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerCreateContent(
      body: CreateContentDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerCreateContent(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [slug]
     * @param {string} [ticketTraceCode]
     * @param {string} [m3u8FileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetCinemaContentM3U8Resource(
      slug?: string,
      ticketTraceCode?: string,
      m3u8FileName?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerGetCinemaContentM3U8Resource(
          slug,
          ticketTraceCode,
          m3u8FileName,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} anaVatanCity
     * @param {string} anaVatanProvince
     * @param {string} [title]
     * @param {string} [slug]
     * @param {Array} [category]
     * @param {Array} [genre]
     * @param {string} [country]
     * @param {string} [yearStartAt]
     * @param {string} [yearEndAt]
     * @param {string} [timeStartAt]
     * @param {string} [timeEndAt]
     * @param {string} [imdbRateStartAt]
     * @param {string} [imdbRateEndAt]
     * @param {string} [artist]
     * @param {string} [kind]
     * @param {string} [contentAgeRange]
     * @param {string} [status]
     * @param {boolean} [lazyLoading]
     * @param {boolean} [isFree]
     * @param {boolean} [isAnaVatan]
     * @param {boolean} [isLive]
     * @param {boolean} [isTicketing]
     * @param {string} [audioLang]
     * @param {string} [audioLangType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContent(
      pageNumber: number,
      pageIndex: number,
      anaVatanCity?: string,
      anaVatanProvince?: string,
      title?: string,
      slug?: string,
      category?: Array,
      genre?: Array,
      country?: string,
      yearStartAt?: string,
      yearEndAt?: string,
      timeStartAt?: string,
      timeEndAt?: string,
      imdbRateStartAt?: string,
      imdbRateEndAt?: string,
      artist?: string,
      kind?: string,
      contentAgeRange?: string,
      status?: string,
      lazyLoading?: boolean,
      isFree?: boolean,
      isAnaVatan?: boolean,
      isLive?: boolean,
      isTicketing?: boolean,
      audioLang?: string,
      audioLangType?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerGetContent(
          pageNumber,
          pageIndex,
          anaVatanCity,
          anaVatanProvince,
          title,
          slug,
          category,
          genre,
          country,
          yearStartAt,
          yearEndAt,
          timeStartAt,
          timeEndAt,
          imdbRateStartAt,
          imdbRateEndAt,
          artist,
          kind,
          contentAgeRange,
          status,
          lazyLoading,
          isFree,
          isAnaVatan,
          isLive,
          isTicketing,
          audioLang,
          audioLangType,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentCountries(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerGetContentCountries(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentGlobalSharedVar(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerGetContentGlobalSharedVar(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentImageMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerGetContentImageMedia(filename, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [slug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentPlayerResource(
      slug?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerGetContentPlayerResource(slug, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerGetContentVideoMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerGetContentVideoMedia(filename, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateContentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerUpdateContent(
      body: UpdateContentDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerUpdateContent(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentControllerUploadContentMedia(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ContentApiFp(configuration)
        .contentControllerUploadContentMedia(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
  /**
   *
   * @param {ContentArtistDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerApplyArtistToContent(
    body: ContentArtistDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerApplyArtistToContent(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {ContentCategoryDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerApplyCategoryToContent(
    body: ContentCategoryDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerApplyCategoryToContent(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateContentDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerCreateContent(
    body: CreateContentDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerCreateContent(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} [slug]
   * @param {string} [ticketTraceCode]
   * @param {string} [m3u8FileName]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerGetCinemaContentM3U8Resource(
    slug?: string,
    ticketTraceCode?: string,
    m3u8FileName?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerGetCinemaContentM3U8Resource(
        slug,
        ticketTraceCode,
        m3u8FileName,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} anaVatanCity
   * @param {string} anaVatanProvince
   * @param {string} [title]
   * @param {string} [slug]
   * @param {Array} [category]
   * @param {Array} [genre]
   * @param {string} [country]
   * @param {string} [yearStartAt]
   * @param {string} [yearEndAt]
   * @param {string} [timeStartAt]
   * @param {string} [timeEndAt]
   * @param {string} [imdbRateStartAt]
   * @param {string} [imdbRateEndAt]
   * @param {string} [artist]
   * @param {string} [kind]
   * @param {string} [contentAgeRange]
   * @param {string} [status]
   * @param {boolean} [lazyLoading]
   * @param {boolean} [isFree]
   * @param {boolean} [isAnaVatan]
   * @param {boolean} [isLive]
   * @param {boolean} [isTicketing]
   * @param {string} [audioLang]
   * @param {string} [audioLangType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerGetContent(
    pageNumber: number,
    pageIndex: number,
    anaVatanCity?: string,
    anaVatanProvince?: string,
    title?: string,
    slug?: string,
    category?: Array,
    genre?: Array,
    country?: string,
    yearStartAt?: string,
    yearEndAt?: string,
    timeStartAt?: string,
    timeEndAt?: string,
    imdbRateStartAt?: string,
    imdbRateEndAt?: string,
    artist?: string,
    kind?: string,
    contentAgeRange?: string,
    status?: string,
    lazyLoading?: boolean,
    isFree?: boolean,
    isAnaVatan?: boolean,
    isLive?: boolean,
    isTicketing?: boolean,
    audioLang?: string,
    audioLangType?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerGetContent(
        pageNumber,
        pageIndex,
        anaVatanCity,
        anaVatanProvince,
        title,
        slug,
        category,
        genre,
        country,
        yearStartAt,
        yearEndAt,
        timeStartAt,
        timeEndAt,
        imdbRateStartAt,
        imdbRateEndAt,
        artist,
        kind,
        contentAgeRange,
        status,
        lazyLoading,
        isFree,
        isAnaVatan,
        isLive,
        isTicketing,
        audioLang,
        audioLangType,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerGetContentCountries(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerGetContentCountries(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerGetContentGlobalSharedVar(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerGetContentGlobalSharedVar(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} filename
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerGetContentImageMedia(
    filename: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerGetContentImageMedia(filename, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} [slug]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerGetContentPlayerResource(
    slug?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerGetContentPlayerResource(slug, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} filename
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerGetContentVideoMedia(
    filename: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerGetContentVideoMedia(filename, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {UpdateContentDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerUpdateContent(
    body: UpdateContentDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerUpdateContent(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public async contentControllerUploadContentMedia(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ContentApiFp(this.configuration)
      .contentControllerUploadContentMedia(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
